import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import {
  // RefreshCcw,
  RotateCw,
  ShoppingCart,
} from "feather-icons-react/build/IconComponents";
import { Check, CheckCircle, Trash2 } from "react-feather";
import Select from "react-select";
import PlusCircle from "feather-icons-react/build/IconComponents/PlusCircle";
import MinusCircle from "feather-icons-react/build/IconComponents/MinusCircle";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  API_BASE_URL,
  INSERT_ORDERS,
  GET_CATEGORIES_ITEMS,
  GET_VSTORE_POS_PROD,
  GET_ORDERS,
  GET_METAL_RATES,
  GET_TAXES_DATA,
  GET_PAYMENTS_TYPES,
  IMAGE_URL_IBIZ,
  INSET_CUSTOMER,
  GET_DDL,
  GET_ORDER_VIEW,
} from "../../Config";
import Axios from "axios";
import AllCategoryImage from "./categories.png";
import PrintLogo from "./vaibhav.png";
import { Popover } from "antd";
import html2pdf from "html2pdf.js";


const JewelleryPOS = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const [categoriesData, setCategoriesData] = useState([]);
  const [catLoadingData, setCatLoadingData] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [ordersData, setOrdersData] = useState([]);
  const [productsDDL, setProductsDDL] = useState([]);
  const [taxesData, setTaxesData] = useState([]);
  const [selectedCatId, setSelectedCatId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCusId, setSelectedCusId] = useState(null);
  const [customersDDL, setCustomersDDL] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [metalRates, setMetalRates] = useState([]);
  const [paymentType, setSelectedPaymentType] = useState(null);
  const [selectedDisType, setSelectedDisType] = useState(null);
  const [taxRate, setTaxRate] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountPerc, setDiscountPerc] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  // const [totalAmount, setTotalAmount] = useState(0);
  const [selectedExchangeProducts, setSelectedExchangeProducts] = useState([]);
  const [totalExchangeAmount, setTotalExchangeAmount] = useState(0);
  // const [selectedOrderIdView, setSelectedOrderIdView] = useState(0);
  const [orderViewData, setOrderViewData] = useState([]);
  const [orderViewLoading, setOrderViewLoading] = useState(false);
  const [orderDownlaodData, setOrderDownlaodData] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);
  const [isVisible, setIsVisible] = useState(false);
  const [offcanvasWidth, setOffcanvasWidth] = useState("40%");
  const [enteredPrice, setEnteredPrice] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const [barcode, setBarcode] = useState("");
  const [scannedBarcode, setScannedBarcode] = useState("");
  const inputRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const updateWidth = () => {
      setOffcanvasWidth(window.innerWidth < 768 ? "80%" : "40%");
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    inputRef.current.focus();
  }, []);
  // console.log(productsList)

  const handleKeyPress = (e) => {
    if (e.key.length === 1) {
      setBarcode((prev) => prev + e.key);
    }

    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      console.log("Scanned Barcode:", barcode);

      // const localProduct = productsList.find(
      //   (product) => product.BarCode === barcode
      // );

      const localProduct = productsList.find(
        (product) => product.BarCode === barcode || product.InventoryBarcode === barcode
      );
      
      if (localProduct) {
        handleProductSelect({
          value: localProduct.Id,
          label: localProduct.ProductName,
          price: localProduct.AvgPrice,
          barcode: localProduct.BarCode,
          imagePath: localProduct.ImagePath,
        });
      } else {
        alert("Product not found for scanned barcode.");
      }

      setBarcode("");
      setScannedBarcode(barcode);
    }, 300);
  };

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      console.log(userData, 'user session data..');
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data) {
            const allData = response.data.ResultData;

            const ddlNames = [
              "Supplier",
              "CATEGORY",
              "Subcategories",
              "Products",
              "variantypes",
              "TAX",
              "Stores",
              "BRAND",
              "Roles",
              "Staff",
              "Customers",
              "UNITS",
              "Cities",
            ];

            ddlNames.forEach((name) => {
              const filteredData = allData.filter(
                (item) => item.DDLName === name
              );
              sessionStorage.setItem(
                `filteredDDLData_${name}`,
                JSON.stringify(filteredData)
              );
            });

          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    const customersdata = JSON.parse(sessionStorage.getItem("filteredDDLData_Customers"));
      setCustomersDDL(customersdata);
  }, []);

  const getCurrentMonthStart = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}-01`;
  };

  const getTodayDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(now.getDate()).padStart(2, "0")}`;
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(`${API_BASE_URL}${GET_ORDERS}`, {
        params: {
          OrgId: userDataSession.OrgId,
          STdt: getCurrentMonthStart(),
          enddt: getTodayDate(),
          PosId: 0,
          OrderNo: 0,
          StoreId: userDataSession.StoreId,
        },
      })
        .then((response) => {
          if (response.data) {
            if (response.data.ResultData[0].Status !== "Failure") {
              setOrdersData(response.data.ResultData);
            } else {
              console.error(
                "Error fetching data:",
                response.data.ResultData[0].ResultMessage
              );
              setOrdersData([]);
            }
          } else {
            setOrdersData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          // setLoading(false);
          setOrdersData([]);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setCatLoadingData(true);
      Axios.get(
        `${API_BASE_URL}${GET_CATEGORIES_ITEMS}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setCatLoadingData(false);
            setCategoriesData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          setCatLoadingData(false);
          console.error("Error fetching data:", error);
        });
      Axios.get(
        `${API_BASE_URL}${GET_PAYMENTS_TYPES}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setPaymentTypes(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      Axios.get(
        `${API_BASE_URL}${GET_METAL_RATES}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setMetalRates(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setTaxesData(response.data.Resultdata);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && userDataSession.UserId) {
      setLoading(true);

      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        ProductId: 0,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 0,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_POS_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsList(response.data.ResultData);
            setProductsDDL(response.data.ResultData);
            // console.log(response.data.ResultData, 'ResultDataResultData');
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (
      userDataSession &&
      userDataSession.OrgId &&
      userDataSession.UserId &&
      selectedCatId
    ) {
      setLoading(true);
      console.log(selectedCatId, 'selectedCatIdselectedCatIdselectedCatId')
      console.log(productsList)

      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: selectedCatId,
        BarCode: "0",
        ProductId: 0,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 0,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_POS_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsList(response.data.ResultData);
            console.log(response.data, 'ddddds')
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [selectedCatId]);

  const discountType = [
    { value: "", label: "Choose" },
    { value: "1", label: "Fixed" },
    { value: "2", label: "Percentage" },
  ];
  const discount = [
    { value: "5", label: "5%" },
    { value: "10", label: "10%" },
    { value: "15", label: "15%" },
    { value: "20", label: "20%" },
    { value: "25", label: "25%" },
    { value: "30", label: "30%" },
  ];

  const handleDecrement = (index) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product, i) =>
        i === index && product.quantity > 1
          ? { ...product, quantity: product.quantity - 1 }
          : product
      )
    );
  };

  //region Function to increment quantity of a product
  const handleIncrement = (index) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product, i) =>
        i === index ? { ...product, quantity: product.quantity + 1 } : product
      )
    );
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );

  const settings = {
    dots: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 400,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const MySwal = withReactContent(Swal);

  const handleDeleteProduct = (index) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.filter((_, i) => i !== index)
    );
  };

  const showConfirmationAlert = (index) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteProduct(index);
      } else {
        MySwal.close();
      }
    });
  };

  const getFirstLetter = (str) => {
    const match = str.match(/[a-zA-Z]/);
    return match ? match[0].toUpperCase() : "N/A";
  };

  const handleClearAllProducts = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, clear all!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setSelectedProducts([]);
        setSelectedDisType(null);
        setDiscountPerc(null);
        setDiscountAmount(null);
        setTaxRate(null);
        setScannedBarcode('');
      } else {
        MySwal.close();
      }
    });
  };

  const handleCustomerSelect = (selectedOption) => {
    setSelectedCusId(selectedOption.value);
  };

  // const handleProductSelect = (product) => {
  //   setSelectedProducts((prevProducts) => {
  //     const existingProduct = prevProducts.find(
  //       (p) => p.barcode === product.barcode && p.value === product.value
  //     );

  //     console.log("existingProduct:", existingProduct);

  //     if (existingProduct) {
  //       return prevProducts.map((p) =>
  //         p.barcode === product.barcode && p.value === product.value
  //           ? { ...p, quantity: p.quantity + 1 }
  //           : p
  //       );
  //     } else {
  //       return [
  //         ...prevProducts,
  //         {
  //           ...product,
  //           quantity: 1,
  //           price: product.price,
  //           barcode: product.barcode,
  //           id: product.id,
  //           imagePath: product.imagePath,
  //           weight: "",
  //           makingCharges: "",
  //           otherCharges: "",
  //           materialId: "",
  //           // sku: product.sku,
  //           // categoryanme: item.categoryname,
  //         },
  //       ];
  //     }
  //   });
  // };

  // const handleProductSelect = (product) => {
  //   console.log(product, 'clickedd product ')
  //   if (product.price == 0) {
  //     setSelectedProduct(product);
  //     setEnteredPrice(""); // Clear previous input
  //     setShowModal(true); // Show modal
  //   } else {
  //     addProductToSelectedList(product);
  //   }
  // };
  
  
  // Function to add product to selectedProducts
  
  const handleProductSelect = (product) => {
    const existingProduct = selectedProducts.find(
      (p) => p.barcode === product.barcode && p.value === product.value
    );
  
    if (existingProduct) {
      // If the product already exists, increase its quantity
      setSelectedProducts((prevProducts) =>
        prevProducts.map((p) =>
          p.barcode === product.barcode && p.value === product.value
            ? { ...p, quantity: p.quantity + 1 }
            : p
        )
      );
    } else if (product.price === 0) {
      // If price is zero and product is new, show the modal to enter price
      setSelectedProduct(product);
      setEnteredPrice(""); // Clear previous input
      setShowModal(true); // Show modal
    } else {
      // If product has a non-zero price, add it directly
      addProductToSelectedList(product);
    }
  };

  const handleSubmitPrice = () => {
    if (selectedProduct && enteredPrice) {
      const productWithPrice = { ...selectedProduct, price: Number(enteredPrice), quantity: 1 };
      addProductToSelectedList(productWithPrice);
      setShowModal(false);
      setSelectedProduct(null);
    }
  };
  
  
  
  const addProductToSelectedList = (product) => {
    setSelectedProducts((prevProducts) => {
      const existingProduct = prevProducts.find(
        (p) => p.barcode === product.barcode && p.value === product.value
      );
  
      if (existingProduct) {
        return prevProducts.map((p) =>
          p.barcode === product.barcode && p.value === product.value
            ? { ...p, quantity: p.quantity + 1 }
            : p
        );
      } else {
        return [
          ...prevProducts,
          {
            ...product,
            quantity: 1,
            price: product.price,
            barcode: product.barcode,
            id: product.value,
            imagePath: product.imagePath,
            weight: "",
            makingCharges: "",
            otherCharges: "",
            materialId: "",
          },
        ];
      }
    });
  };

  // const handleSubmitPrice = () => {
  //   if (selectedProduct && enteredPrice) {
  //     const productWithPrice = { ...selectedProduct, price: Number(enteredPrice) };
  //     addProductToSelectedList(productWithPrice);
  //     setShowModal(false);
  //     setSelectedProduct(null);
  //   }
  // };
  
  const handleClose = () => {
    setShowModal(false);
  };
  

  const handleUpdateProductCharges = (index, field, value) => {
    setSelectedProducts((prevProducts) => {
      const updatedProducts = [...prevProducts];
      updatedProducts[index] = {
        ...updatedProducts[index],
        [field]: value,
      };
      return updatedProducts;
    });
  };

  const styles = {
    imagePlaceholder: {
      width: "3rem",
      height: "3rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      fontSize: "20px",
      color: "#fff",
      backgroundColor: "#FF9F43",
    },
    productImage: {
      width: "3rem",
      height: "3rem",
      objectFit: "cover",
    },
    productInfo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center",
      minHeight: "4rem",
      paddingLeft: "10px",
    },
    barcodeText: {
      fontSize: "0.85rem",
      color: "#FFFFFF",
      fontWeight: "900",
    },
    productTitle: {
      margin: 0,
      fontSize: "13px",
      fontWeight: "bold",
    },
    productPrice: {
      margin: 0,
      fontSize: "12px",
      // color: '#333',
    },
  };

  const handlePaymentTypeChange = (selectedOption) => {
    setSelectedPaymentType(selectedOption.value);
    console.log(paymentType);
  };

  const handleDiscountTypeChange = (selectedOption) => {
    setSelectedDisType(selectedOption.value);
  };

  const handleDiscountPercChange = (selectedOption) => {
    setDiscountPerc(selectedOption.value);
  };

  const handleTaxChange = (selectedOption) => {
    setTaxRate(selectedOption.value);
    console.log(selectedOption);
  };

  // region func caluclate amounts
  const calculateAmounts = () => {
    let subtotal = 0;
    let totalDiscount = 0;
    let totalTax = 0;

    selectedProducts.forEach((product) => {
      subtotal += product.price * product.quantity;
    });

    // console.log(selectedDisType, 'dis type');
    if (selectedDisType == 1) {
      totalDiscount = discountAmount;
    } else if (selectedDisType == 2) {
      totalDiscount = (discountPerc / 100) * subtotal;
    }

    const taxableAmount = subtotal - totalDiscount;
    totalTax = (taxRate / 100) * taxableAmount;

    const finalTotal = taxableAmount + totalTax - totalExchangeAmount;

    return {
      subtotal,
      totalDiscount,
      totalTax,
      finalTotal,
    };
  };

  const amounts = calculateAmounts();

  //region Submit Order
  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    console.log(selectedProducts, "selected products");

    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      OrgType: 0,
      BillNo: null,
      Order: {
        StoreId: userDataSession.StoreId,
        PosId: 0,
        OrderType: 1,
        Total: amounts?.finalTotal || 0,
        Discount: discountAmount || 0,
        SGST: taxRate,
        CGST: taxRate,
        IGST: taxRate,
        Status: 1,
        IsActive: 1,
        Orderdate: selectedDate,
        DiscountId: 0,
        DiningId: 0,
        ReturnFromOrdId: 0,
        CustomerId: selectedCusId || 0,
        PriceListId: 0,
        TransportMode: "NULL",
        TransportvehicleNumber: "NULL",
        AdditionalCharges: 0,
        AdditionalRoundOffAmount: 0,
        IsAcknowledge: 0,
        TransportAmount: 0,
        InvoiceNo: "NULL",
        EmpId: userDataSession.UserId,
      },
      OrderDetails: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        Quantity: prod.quantity,
        UnitPrice: prod.price,
        Discount: discountAmount || 0,
        SGST: taxRate,
        CGST: taxRate,
        IGST: 0,
        Total: prod.price * prod.quantity,
        Status: 1,
        RefundQuantity: 0,
        IsActive: 1,
        VendorId: 0,
        IsComplement: 0,
        CGSTrate: 9,
        SGSTrate: 9,
        IGSTrate: 0,
        NoOfBags: 0,
        Comments: "NULL",
        ItemWeight: prod.weight,
        ItemPackingWeight: 0,
        BilledBarCode: "NULL",
      })),
      OrderAdditionalDetails: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        MakingCharges: prod.makingCharges,
        OtherCharges: prod.otherCharges,
        MetalRateId: prod.materialId,
      })),
      OrderPayments: [
        {
          PaymentTypeId: 1,
          PaidAmount: 0,
          CardNo: "NULL",
          MobileNo: "NULL",
        },
      ],
      StockHistory: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId,
        StockEffectTypeId: 0,
        StockAdjusted: prod.quantity,
        TransactionId: 0,
        TransfarStockId: 0,
        StockAdjustId: 0,
        IsActive: 1,
        SupplierId: 0,
      })),
      StoreProducts: selectedProducts.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId,
        StockAdjusted: -prod.quantity,
      })),
    };

    console.log(requestPayload, "data sending to service...");

    // setSubmitLoading(true);

    Axios.post(`${API_BASE_URL}${INSERT_ORDERS}`, requestPayload)
      .then((response) => {
        const data = response.data;
        console.log(data, "reponse data getting from api");
        // setSubmitLoading(false);
        if (data[0].OrderId >= 1) {
          Swal.fire({
            title: "Success",
            text: "Order added successfully.",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to added order.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        // setSubmitLoading(false);
        Swal.fire({
          title: "Error",
          text: "An error occurred while adding the order.",
          icon: "error",
        });
        console.error("Error:", error);
      });
  };

  const [formData, setFormData] = useState({
    orgid: userDataSession.OrgId,
    userid: userDataSession.UserId,
    Customer: {
      Name: "",
      Email: "",
      Mobile: "",
      IsActive: 1,
    },
    Address: {
      IsActive: 1,
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      Customer: {
        ...prevData.Customer,
        [name]: value,
      },
    }));
  };

  const handleCustomerSubmit = async (e) => {
    e.preventDefault();
    try {
      formData.userid = userDataSession.UserId;
      formData.orgid = userDataSession.OrgId;
      const response = await Axios.post(
        `${API_BASE_URL}${INSET_CUSTOMER}`,
        formData
      );
      console.log("Response:", response.data);
      setIsSubmitted(true);
      alert("Customer added successfully!");
    } catch (error) {
      console.error("Error submitting customer data:", error);
      alert("Error submitting data");
    }
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && isSubmitted) {
      Axios.get(
        `${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data) {
            const allData = response.data.ResultData;

            const ddlNames = [
              "Supplier",
              "CATEGORY",
              "Subcategories",
              "Products",
              "variantypes",
              "TAX",
              "Stores",
              "BRAND",
              "Roles",
              "Staff",
              "Customers",
              "UNITS",
              "Cities",
            ];

            ddlNames.forEach((name) => {
              const filteredData = allData.filter(
                (item) => item.DDLName === name
              );
              sessionStorage.setItem(
                `filteredDDLData_${name}`,
                JSON.stringify(filteredData)
              );
            });

            console.log("Filtered data saved successfully");
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession, isSubmitted]);

  const getContent = (details) => (
    <div style={{ width: "16rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          textAlign: "start",
        }}
      >
        <p>
          <strong>Category:</strong>
        </p>
        <p>{details.categoryname}</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          textAlign: "start",
        }}
      >
        <p>
          <strong>Barcode:</strong>
        </p>
        <p>{details.barcode}</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          textAlign: "start",
        }}
      >
        <p>
          <strong>Stock:</strong>
        </p>
        <p>{details.stock}</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          textAlign: "start",
        }}
      >
        <p>
          <strong>SKU:</strong>
        </p>
        <p>{details.sku}</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          textAlign: "start",
        }}
      >
        <p>
          <strong>Description:</strong>
        </p>
        <p>N/A</p>
      </div>
    </div>
  );

  const handleSelectProduct = (selectedOption) => {
    const selectedProduct = productsList.find(
      (prod) => prod.Id === selectedOption.value
    );

    if (!selectedProducts.some((prod) => prod.Id === selectedProduct.Id)) {
      setSelectedExchangeProducts((prev) => [...prev, selectedProduct]);

      setTotalExchangeAmount((prev) => prev + selectedProduct.AvgPrice);
    }
  };

  useEffect(() => {
    const total = selectedExchangeProducts.reduce(
      (sum, item) => sum + item.AvgPrice * item.quantity,
      0
    );
    setTotalExchangeAmount(total);
  }, [selectedExchangeProducts]);

  const handleQuantityChange = (index, qty) => {
    const updatedProducts = selectedExchangeProducts.map((item, i) =>
      i === index ? { ...item, quantity: qty } : item
    );
    setSelectedExchangeProducts(updatedProducts);
  };

  //region Handle remove cart item
  const handleRemoveItem = (index) => {
    const updatedProducts = selectedExchangeProducts.filter(
      (_, i) => i !== index
    );
    setSelectedExchangeProducts(updatedProducts);
  };

  const formatOrderDate = (orderDate) => {
    const date = new Date(orderDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const printRef = useRef();

  useEffect(() => {
    if (orderDownlaodData.length > 0) {
      const element = printRef.current;
      setIsVisible(true);
      html2pdf().from(element).save("Order.pdf").then(() => {
        setIsVisible(false);
      }).catch((error) => {
        console.error('Error generating PDF:', error);
        setIsVisible(false);
      });
    } else {
      setIsVisible(false);
    }
  }, [orderDownlaodData]);

  const downloadPDF = (id) => {
    Axios.get(`${API_BASE_URL}${GET_ORDER_VIEW}?OrgId=${userDataSession.OrgId}&OrderId=${id}`)
      .then((response) => {
        if (response.data.Status) {
          setOrderDownlaodData(response.data.ResultData);
        } else {
          console.error("Error fetching data:", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const viewOrderData = (id) => {
    Axios.get(`${API_BASE_URL}${GET_ORDER_VIEW}?OrgId=${userDataSession.OrgId}&OrderId=${id}`)
      .then((response) => {
        if (response.data.Status) {
          setOrderViewLoading(true);
          setOrderViewData(response.data.ResultData);
        } else {
          setOrderViewLoading(false);
          console.error("Error fetching data:", response.data.Message);
        }
      })
      .catch((error) => {
        setOrderViewLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  // const handleProductClick = (item) => {
  //   if (item.AvgPrice === 0) {
  //     setSelectedProduct(item);
  //     // setShowPriceModal(true);
  //   } else {
  //     handleProductSelect({
  //       value: item.Id,
  //       label: item.ProductName,
  //       price: item.AvgPrice,
  //       barcode: item.BarCode,
  //       imagePath: item.ImagePath,
  //       stock: item.StockByUsers,
  //       sku: item.ProductSKU,
  //       categoryname: item.CategoryName,
  //     });
  //   }
  // };
 
  
  return (
    <div>
      <div className="page-wrapper pos-pg-wrapper ms-0">
        <div className="conten pos-design p-0 bg-white">
          <div className="row align-items-start pos-wrapper">
            <div className="col-md-12 col-lg-8 d-none d-md-block d-xl-block">
              <div className="pos-categories tabs_wrapper">
                {catLoadingData ? (
                  <p className="mb-5">Loading...</p>
                ) : (
                  <Slider {...settings}>
                    <div
                      id="all"
                      className="pos-slick-item card m-0"
                      onClick={() => setSelectedCatId(0)}
                    >
                      <div
                        className="card-bod m-1 mt-2 text-center"
                        style={{ height: "6.4rem" }}
                      >
                        <img
                          src={AllCategoryImage}
                          alt="Category"
                          className="m-auto d-flex text-center "
                          style={{
                            width: "3rem",
                            height: "3rem",
                            borderRadius: "10px",
                          }}
                          onClick={() => setSelectedCatId(0)}
                        />
                        <h6 onClick={() => setSelectedCatId(0)}>
                          <Link to="#">All Categories</Link>
                        </h6>
                        <span className="text-info fw-bold">
                          {categoriesData.reduce(
                            (total, category) => total + category.ProductCount,
                            0
                          )}{" "}
                          Items
                        </span>
                      </div>
                    </div>
                    {categoriesData &&
                      categoriesData.map((item, index) => (
                        <div
                          key={index}
                          id={`headphones${index}`}
                          className="card pos-slick-item"
                          style={{ height: "6.7rem" }}
                          onClick={() => setSelectedCatId(item.CategoryId)}
                        >
                          <div className="card-bod mt-2 m-1 text-center">
                            <img
                              src={`${IMAGE_URL_IBIZ}${item.ImagePath}`}
                              alt="Category"
                              className="m-auto d-flex text-center"
                              style={{
                                width: "3rem",
                                height: "3rem",
                                borderRadius: "10px",
                              }}
                            />
                            <h6 title={item.Name}>
                              <Link to="#" className="text-primary">
                                {item.Name.length > 13
                                  ? `${item.Name.substring(0, 13)}...`
                                  : item.Name}
                              </Link>
                            </h6>
                            <span className="text-info fw-semibold">
                              {item.ProductCount} Items
                            </span>
                          </div>
                        </div>
                      ))}
                  </Slider>
                )}

                <div className="pos-products">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-0">Products</h5>
                  </div>
                  <div className="tabs_container">
                    <div
                      className="tab_content active"
                      data-tab="all"
                      style={{ maxHeight: "42rem", overflowY: "auto" }}
                    >
                      <div className="row">
                        {loading ? (
                          <div className="loader m-auto"></div>
                        ) : (
                          productsList &&
                          productsList?.map((item, index) => (
                            <div
                              className="col-sm-2 col-md-6 col-lg-3 col-xl-3"
                              key={index}
                              onClick={() =>
                                 handleProductSelect({
                                      value: item.Id,
                                      label: item.ProductName,
                                      price: item.AvgPrice,
                                      barcode: item.BarCode,
                                      imagePath: item.ImagePath,
                                      stock: item.StockByUsers,
                                      sku: item.ProductSKU,
                                      categoryname: item.CategoryName,
                                    })
                              }
                              // data-bs-toggle="modal"
                              //   data-bs-target="#add-price"
                              // onClick={() =>
                                // item.AvgPrice === 0
                                //   ? openModal(item)
                                //   :
                              //   handleProductSelect({
                              //     value: item.Id,
                              //     label: item.ProductName,
                              //     price: item.AvgPrice,
                              //     barcode: item.BarCode,
                              //     imagePath: item.ImagePath,
                              //     stock: item.StockByUsers,
                              //     sku: item.ProductSKU,
                              //     categoryname: item.CategoryName,
                              //   })
                              // }
                            >
                              <div
                                className="product-info default-cover card"
                                style={{ height: "7.5rem" }}
                              >
                                <div className="d-flex align-items-center justify-content-between">
                                  <Link
                                    to="#"
                                    className="img-bg"
                                    style={{ height: "3rem" }}
                                  >
                                    {item.ImagePath ? (
                                      <img
                                        src={`https://pcuploadfiles.azurewebsites.net/download?path=${item.ImagePath}`}
                                        alt="Product"
                                        style={{ height: "3rem" }}
                                        className="rounded"
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          backgroundColor: "#FF9F43",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          borderRadius: "50%",
                                          fontSize: "18px",
                                          color: "#fff",
                                        }}
                                      >
                                        {item
                                          ? getFirstLetter(item.ProductName)
                                          : "N/A"}
                                      </div>
                                    )}
                                    <span>
                                      <Check className="feather-16" />
                                    </span>
                                  </Link>

                                  <div className="price text-end">
                                    <span className="fw-semibold">
                                      {item.StockByUsers} Pcs
                                    </span>
                                    <p className="mb-0 fw-bold">
                                      ₹{item.AvgPrice.toLocaleString("en-IN")}
                                    </p>
                                  </div>
                                </div>
                                <p className="product-name fw-bold">
                                  <Link to="#" title={item.ProductName}>
                                    {item.ProductName.length > 25 ? `${item.ProductName.slice(0, 20)}...` : item.ProductName}
                                  </Link>
                                </p>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-4 ps-0 mt-4 sm-mt-1 xs-mt-1">
              <h1 className="text-center d-block d-md-none d-xl-none d-lg-none">Add Bill</h1>
              <aside
                className="product-order-list"
                style={{ borderStartEndRadius: "20px" }}
              >
                <div
                  className="btn-ro d-flex flex-nowrap align-items-center"
                  style={{ marginTop: "-1.8rem" }}
                >
                  <Link
                    to="#"
                    className="btn btn-secondary col-auto mb-2 mb-sm-0 me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightViewOrdersList"
                    aria-controls="offcanvasRightViewOrdersList"
                    title="Orders"
                  >
                    <span className="d-flex align-items-center">
                      <ShoppingCart className="feather-16" />
                    </span>
                  </Link>
                  <Link to="#" className="btn btn-info col-auto mb-2 mb-sm-0 me-2" title="Refresh">
                    <span className="d-flex align-items-center">
                      <RotateCw className="feather-16" />
                    </span>
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary col-auto mb-2 mb-sm-0 me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#recents"
                    title="Transactions"
                  >
                    <span className="d-flex align-items-center">
                      {/* <RefreshCcw className="feather-16" /> */}
                      <i className="fa-solid fa-right-left"></i>
                    </span>
                  </Link>
                  <input
                    type="date"
                    className="form-control col-auto ms-auto"
                    style={{ width: "10rem" }}
                    value={selectedDate}
                    onChange={handleDateChange}
                  />
                </div>
                <div className="customer-info block-sectio">
                  <label>Customer</label>
                  <div className="input-block d-flex align-items-center">
                    <div className="flex-grow-1">
                      <Select
                        options={customersDDL?.map((prod) => ({
                          value: prod.ItemId,
                          label: prod.ItemValue,
                        }))}
                        className="select"
                        placeholder="Select an customer"
                        onChange={handleCustomerSelect}
                      />
                    </div>
                    <a
                      href="#"
                      className="btn btn-primary btn-icon"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRightAddCust"
                      aria-controls="offcanvasRightAddCust"
                    >
                      <i className="fa-solid fa-user-plus"></i>
                    </a>
                  </div>
                  <div className="d-flex align-items-center mt-1">
                    <div className="col-12 col-md-8 col-lg-8">
                      <label>Product</label>
                      <Select
                        options={productsDDL?.map((prod) => ({
                          value: prod.Id,
                          label: prod.ProductName,
                          price: prod.AvgPrice,
                          barcode: prod.BarCode,
                          imagePath: prod.ImagePath,
                          stock: prod.StockByUsers,
                          categoryname: prod.CategoryName,
                          sku: prod.ProductSKU,
                        }))}
                        className="select"
                        placeholder="Select a product"
                        onChange={handleProductSelect}
                      />
                    </div>
                    <div
                      className="col-4 d-none d-md-block d-xl-block"
                      style={{ position: "relative", marginLeft: "10px" }}
                    >
                      <label>Barcode</label>
                      <i
                        className="fa-solid fa-barcode"
                        style={{
                          position: "absolute",
                          top: "70%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          color: "#ccc",
                        }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Barcode"
                        ref={inputRef}
                        value={scannedBarcode}
                        onKeyPress={handleKeyPress}
                        style={{ paddingLeft: "35px" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="product-added block-section">
                  <div className="head-text d-flex align-items-center justify-content-between">
                    <h6 className="d-flex align-items-center mb-0">
                      Products Added
                      <span className="count ms-2">
                        {selectedProducts?.length}
                      </span>
                    </h6>

                    <div className="d-flex align-items-center ms-auto">
                      <Link
                        className="btn-icon edit-icon me-3 border rounded"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasRightItemEdit"
                        aria-controls="offcanvasRightItemEdit"
                      >
                        {/* ₹ */}
                        <i className="fa-solid fa-scale-unbalanced-flip fs-5"></i>
                      </Link>

                      <Link
                        to="#"
                        className="d-flex align-items-center text-danger"
                        onClick={handleClearAllProducts}
                      >
                        <span className="me-1">
                          <i data-feather="x" className="feather-16" />
                        </span>
                        Clear all
                      </Link>
                    </div>
                  </div>
                  <div className="product-wrap">
                    {selectedProducts?.map((item, index) => (
                      <div
                        className="product-list d-flex align-items-center justify-content-between"
                        key={index}
                        style={{ height: "2.4rem" }}
                      >
                        <div
                          className="d-flex align-items-center product-info"
                          data-bs-toggle="modal"
                          data-bs-target="#products"
                        >
                          <div style={styles.productInfo} className="info">
                            <Popover
                              placement="bottom"
                              content={getContent(item)}
                            >
                              <h6 style={styles.productTitle}>
                                <Link to="#">{item.label}</Link>
                              </h6>
                            </Popover>
                            <p
                              style={styles.productPrice}
                              className="text-info"
                            >
                              ₹{item.price.toLocaleString("en-IN")}
                            </p>
                          </div>
                        </div>
                        <div className="qty-item text-center">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-minus">Minus</Tooltip>
                            }
                          >
                            <Link
                              to="#"
                              className="dec d-flex justify-content-center align-items-center"
                              onClick={() => handleDecrement(index)}
                            >
                              <MinusCircle className="feather-14" />
                            </Link>
                          </OverlayTrigger>

                          <input
                            type="text"
                            className="form-control text-center"
                            name="qty"
                            value={item.quantity}
                            readOnly
                          />
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-plus">Plus</Tooltip>}
                          >
                            <Link
                              to="#"
                              onClick={() => handleIncrement(index)}
                              className="inc d-flex justify-content-center align-items-center"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="plus"
                            >
                              <PlusCircle className="feather-14" />
                            </Link>
                          </OverlayTrigger>
                        </div>
                        <div className="d-flex align-items-center action">
                          {/* <Link
                            className="btn-icon edit-icon me-2"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightItemEdit"
                            aria-controls="offcanvasRightItemEdit"
                          >
                            <Edit className="feather-14" />
                          </Link> */}
                          <Link
                            onClick={() => showConfirmationAlert(index)}
                            className="btn-icon delete-icon confirm-text"
                            to="#"
                          >
                            <Trash2 className="feather-14" />
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="block-section" style={{ marginTop: "-2.2rem" }}>
                  <div className="col-12">
                    <div
                      className="accordion accordion-primary"
                      id="accordionPrimaryExample"
                    >
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingPrimaryOne">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsePrimaryOne"
                            aria-expanded="true"
                            aria-controls="collapsePrimaryOne"
                          >
                            Billing Details #
                          </button>
                        </h2>
                        <div
                          id="collapsePrimaryOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingPrimaryOne"
                          data-bs-parent="#accordionPrimaryExample"
                        >
                          <div className="accordion-body">
                            <div className="selling-info">
                              <div className="row">
                                <div className="col-12 col-sm-4">
                                  <div className="input-block">
                                    <label>Order Tax</label>
                                    <Select
                                      className="select"
                                      options={taxesData}
                                      placeholder="Tax rate"
                                      onChange={handleTaxChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-12 col-sm-4">
                                  <div className="input-block">
                                    <label>Discount Type</label>
                                    <Select
                                      className="select"
                                      options={discountType}
                                      placeholder="Type"
                                      onChange={handleDiscountTypeChange}
                                    />
                                  </div>
                                </div>
                                <div
                                  className={`col-12 col-sm-4 ${
                                    selectedDisType == 2 ? "d-block" : "d-none"
                                  }`}
                                >
                                  <div className="input-block">
                                    <label>Discount</label>
                                    <Select
                                      className="select"
                                      options={discount}
                                      placeholder="Choose"
                                      onChange={handleDiscountPercChange}
                                    />
                                  </div>
                                </div>
                                <div
                                  className={`col-12 col-sm-4 ${
                                    selectedDisType == 1 ? "d-block" : "d-none"
                                  }`}
                                >
                                  <div className="input-block">
                                    <label>Discount</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter amount"
                                      onChange={(e) =>
                                        setDiscountAmount(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="order-total">
                              <table className="table table-responsive table-borderless">
                                <tbody>
                                  <tr>
                                    <td>Sub Total</td>
                                    <td className="text-end">
                                      ₹
                                      {amounts.subtotal ? amounts.subtotal.toLocaleString("en-IN") : "0"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Tax (GST {taxRate}%)</td>
                                    <td className="text-end">
                                      ₹
                                      {amounts.totalTax ? amounts.totalTax.toLocaleString("en-IN") : "0"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="danger d-flex">
                                      Discount{" "}
                                      <span
                                        className={`ms-1 ${
                                          selectedDisType == 2
                                            ? "d-block"
                                            : "d-none"
                                        }`}
                                      >
                                        ({discountPerc})
                                      </span>
                                    </td>
                                    <td className="danger text-end">
                                      ₹
                                      {amounts.totalDiscount ? amounts.totalDiscount.toLocaleString("en-IN") : "0"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Total</td>
                                    <td className="text-end">
                                      ₹
                                      {amounts.totalDiscount ? amounts.finalTotal.toLocaleString("en-IN") : "0"}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            <div className="block-section payment-method">
                              <h6>Payment Method</h6>
                              <Select
                                className="select"
                                id="categorySelect"
                                onChange={handlePaymentTypeChange}
                                options={paymentTypes?.map((ptypes) => ({
                                  value: ptypes.Id,
                                  label: ptypes.Name,
                                }))}
                                placeholder="Choose type"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-md-6 col-lg-4 col-xl-4 pb-1"
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
        >
          <div className="d-flex col-12  justify-content-between mb-1">
            <div
              className="text-center col-6 bg-primary rounded gap-1"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightItemExchange"
              aria-controls="offcanvasRightItemExchange"
              style={{ cursor: "pointer" }}
            >
              Exchange Item
            </div>
            <div
              className="text-center col-6 fw-bold text-dark rounded"
              style={{ height: "1.6rem", backgroundColor: "#BCC9D0" }}
            >
              Grand Total: ₹{amounts?.finalTotal?.toLocaleString("en-IN")}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <Link
              to="#"
              className="btn btn-info btn-icon flex-fill"
              data-bs-toggle="modal"
              data-bs-target="#hold-order"
            >
              <i className="fa-regular fa-circle-pause me-1"></i> 
              <span className="d-none d-md-block d-lg-block d-xl-block">Hold</span>
            </Link>
            <Link to="#" className="btn btn-danger btn-icon flex-fill">
              <i className="fa-regular fa-trash-can me-1"></i> 
              <span className="d-none d-md-block d-lg-block d-xl-block">Void</span>
            </Link>
            <button
              className="btn btn-success btn-icon flex-fill"
              onClick={handleSubmit}
            >
              <i className="fa-regular fa-credit-card me-1"></i>
              <span className="d-none d-md-block d-lg-block d-xl-block">Payment</span>
            </button>
          </div>
        </div>
      </div>

      {/* Add product price */}
      {showModal && (
        <>
          <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(1px)",
            zIndex: 1040,
          }}
        ></div>
          <div className="modal fade show d-block" id="add-price">
              <div className="modal-dialog modal-dialog-centered custom-modal-two">
                  <div className="modal-content">
                      <div className="page-wrapper-new p-0">
                          <div className="content">
                              <div className="modal-header border-0 custom-modal-header">
                                  <div className="page-title">
                                      <h4>Add Price</h4>
                                  </div>
                                  <button
                                      type="button"
                                      className="close d-flex ms-auto"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                      onClick={handleClose}
                                  >
                                      <span aria-hidden="true">×</span>
                                  </button>
                              </div>
                              <div className="modal-body custom-modal-body new-employee-field">
                                  <form>
                                      <div className="mb-3">
                                          <label className="form-label">Price</label>
                                          <input
                                            type="number"
                                            value={enteredPrice}
                                            onChange={(e) => setEnteredPrice(e.target.value)}
                                            onWheel={(e) => e.target.blur()}
                                            placeholder="Enter Price"
                                            className="form-control"
                                            required
                                          />
                                      </div>
                                      <div className="modal-footer-btn">
                                          <button
                                              type="button"
                                              className="btn btn-cancel me-2"
                                              data-bs-dismiss="modal"
                                              onClick={handleClose}
                                          >
                                              Cancel
                                          </button>
                                          <button className="btn btn-submit" onClick={handleSubmitPrice}>
                                              Add
                                          </button>
                                      </div>
                                  </form>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </>
      )}
      {/* Add product price */}

      {/* Payment Completed */}
      <div
        className="modal fade modal-default"
        id="payment-completed"
        aria-labelledby="payment-completed"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <form>
                <div className="icon-head">
                  <Link to="#">
                    <CheckCircle className="feather-40" />
                  </Link>
                </div>
                <h4>Payment Completed</h4>
                <p className="mb-0">
                  Do you want to Print Receipt for the Completed Order
                </p>
                <div className="modal-footer d-sm-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-primary flex-fill me-1"
                    data-bs-toggle="modal"
                    data-bs-target="#print-receipt"
                  >
                    Print Receipt
                  </button>
                  <Link to="#" className="btn btn-secondary flex-fill">
                    Next Order
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Payment Completed */}
      {/* Print Receipt */}
      <div
        className="modal fade modal-default"
        id="print-receipt"
        aria-labelledby="print-receipt"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="icon-head text-center">
                <Link to="#">
                  <ImageWithBasePath
                    src="assets/img/logo.png"
                    width={100}
                    height={30}
                    alt="Receipt Logo"
                  />
                </Link>
              </div>
              <div className="text-center info text-center">
                <h6>Dreamguys Technologies Pvt Ltd.,</h6>
                <p className="mb-0">Phone Number: +1 5656665656</p>
                <p className="mb-0">
                  Email:{" "}
                  <Link to="mailto:example@gmail.com">example@gmail.com</Link>
                </p>
              </div>
              <div className="tax-invoice">
                <h6 className="text-center">Tax Invoice</h6>
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <div className="invoice-user-name">
                      <span>Name: </span>
                      <span>John Doe</span>
                    </div>
                    <div className="invoice-user-name">
                      <span>Invoice No: </span>
                      <span>CS132453</span>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <div className="invoice-user-name">
                      <span>Customer Id: </span>
                      <span>#LL93784</span>
                    </div>
                    <div className="invoice-user-name">
                      <span>Date: </span>
                      <span>01.07.2022</span>
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-borderless w-100 table-fit">
                <thead>
                  <tr>
                    <th># Item</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th className="text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1. Red Nike Laser</td>
                    <td>$50</td>
                    <td>3</td>
                    <td className="text-end">$150</td>
                  </tr>
                  <tr>
                    <td>2. Iphone 14</td>
                    <td>$50</td>
                    <td>2</td>
                    <td className="text-end">$100</td>
                  </tr>
                  <tr>
                    <td>3. Apple Series 8</td>
                    <td>$50</td>
                    <td>3</td>
                    <td className="text-end">$150</td>
                  </tr>
                  <tr>
                    <td colSpan={4}>
                      <table className="table-borderless w-100 table-fit">
                        <tbody>
                          <tr>
                            <td>Sub Total :</td>
                            <td className="text-end">$700.00</td>
                          </tr>
                          <tr>
                            <td>Discount :</td>
                            <td className="text-end">-$50.00</td>
                          </tr>
                          <tr>
                            <td>Shipping :</td>
                            <td className="text-end">0.00</td>
                          </tr>
                          <tr>
                            <td>Tax (5%) :</td>
                            <td className="text-end">$5.00</td>
                          </tr>
                          <tr>
                            <td>Total Bill :</td>
                            <td className="text-end">$655.00</td>
                          </tr>
                          <tr>
                            <td>Due :</td>
                            <td className="text-end">$0.00</td>
                          </tr>
                          <tr>
                            <td>Total Payable :</td>
                            <td className="text-end">$655.00</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="text-center invoice-bar">
                <p>
                  **VAT against this challan is payable through central
                  registration. Thank you for your business!
                </p>
                <Link to="#">
                  <ImageWithBasePath
                    src="assets/img/barcode/barcode-03.jpg"
                    alt="Barcode"
                  />
                </Link>
                <p>Sale 31</p>
                <p>Thank You For Shopping With Us. Please Come Again</p>
                <Link to="#" className="btn btn-primary">
                  Print Receipt
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Print Receipt */}
      {/* Products */}
      <div
        className="modal fade modal-default pos-modal"
        id="products"
        aria-labelledby="products"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header p-4 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="me-4">Products</h5>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <form>
                <div className="product-wrap">
                  {selectedProducts?.map((item, index) => (
                    <div
                      className="product-list d-flex align-items-center justify-content-between"
                      key={index}
                    >
                      <div className="d-flex align-items-center flex-fill">
                        <Link to="#" className="img-bg me-2">
                          {item.ImagePath ? (
                            <img
                              src={`https://pcuploadfiles.azurewebsites.net/download?path=${item.imagePath}`}
                              alt="Product"
                              style={{ height: "3rem" }}
                              className="rounded"
                            />
                          ) : (
                            <div
                              style={{
                                width: "50px",
                                height: "50px",
                                backgroundColor: "#FF9F43",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "50%",
                                fontSize: "18px",
                                color: "#fff",
                              }}
                            >
                              {item ? getFirstLetter(item.label) : "N/A"}
                            </div>
                          )}
                        </Link>
                        <div className="info d-flex align-items-center justify-content-between flex-fill">
                          <div>
                            <h6>
                              <Link to="#">{item.label}</Link>
                            </h6>
                          </div>
                          <p>{item.price}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="modal-footer d-sm-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Products */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightAddCust"
        aria-labelledby="offcanvasRightLabel"
        style={{
          minWidth: offcanvasWidth,
          maxWidth: offcanvasWidth,
        }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Create Customer</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body p-4">
          <form onSubmit={handleCustomerSubmit}>
            <div className="row">
              <div className="col-lg-6 col-sm-12 col-12">
                <label className="form-label">Name </label>
                <spam className="text-danger fw-bold">*</spam>
                <input
                  type="text"
                  name="Name"
                  className="form-control"
                  placeholder="Enter customer name"
                  value={formData.Customer.Name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-lg-6 col-sm-12 col-12">
                <label className="form-label">Phone No </label>
                <span className="text-danger fw-bold">*</span>
                <input
                  type="text"
                  name="Mobile"
                  className="form-control"
                  placeholder="Enter phone number"
                  value={formData.Customer.Mobile}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className=" my-3 col-lg-6 col-sm-12 col-12">
                <label>Email</label>
                <input
                  type="email"
                  name="Email"
                  className="form-control"
                  placeholder="Enter email id"
                  value={formData.Customer.Email}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="modal-footer d-sm-flex justify-content-end">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit me-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Hold */}
      <div
        className="modal fade modal-default pos-modal"
        id="hold-order"
        aria-labelledby="hold-order"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5>Hold order</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <form>
                <h2 className="text-center p-4">₹{amounts?.finalTotal}</h2>
                <div className="input-block">
                  <label>Order Reference</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue=""
                    placeholder=""
                  />
                </div>
                <p>
                  The current order will be set on hold. You can retreive this
                  order from the pending order button. Providing a reference to
                  it might help you to identify the order more quickly.
                </p>
                <div className="modal-footer d-sm-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <Link to="#" className="btn btn-primary">
                    Confirm
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Hold */}

      {/* Add Product Additinoal Details */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightItemEdit"
        aria-labelledby="offcanvasRightLabel"
        style={{
          minWidth: offcanvasWidth,
          maxWidth: offcanvasWidth,
        }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Add Prices</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body p-4">
          {selectedProducts?.map((item, index) => (
            <div key={index} className="row mb-2" style={{ overflowY: "auto" }}>
              <h6>{item.label}</h6>
              <div className="col-lg-3 col-sm-12 col-12">
                <label>
                  Weight <span>*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter item weight"
                  value={item.weight}
                  onChange={(e) =>
                    handleUpdateProductCharges(index, "weight", e.target.value)
                  }
                />
              </div>
              <div className="col-lg-3 col-sm-12 col-12">
                <label>
                  MCR <span>*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter item MCR"
                  value={item.makingCharges}
                  onChange={(e) =>
                    handleUpdateProductCharges(
                      index,
                      "makingCharges",
                      e.target.value
                    )
                  }
                />
              </div>
              <div className="col-lg-3 col-sm-12 col-12">
                <label>
                  Material <span>*</span>
                </label>
                <Select
                  options={metalRates?.map((prod) => ({
                    value: prod.Id,
                    label: prod.MetalType,
                  }))}
                  className="select"
                  placeholder="type"
                  onChange={(e) =>
                    handleUpdateProductCharges(index, "materialId", e.value)
                  }
                  menuPlacement="auto" // Ensures dropdown placement is flexible
                  menuPortalTarget={document.body} // Renders menu outside of the offcanvas
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Sets a high z-index for the dropdown
                  }}
                />
              </div>
              <div className="col-lg-3 col-sm-12 col-12">
                <label>
                  Others <span>*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter other charges"
                  value={item.otherCharges}
                  onChange={(e) =>
                    handleUpdateProductCharges(
                      index,
                      "otherCharges",
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn d-flex m-auto btn-success sticky-bottom"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            OK
          </button>
        </div>
      </div>
      {/* /Add Product Additinoal Details */}

      {/* Exchange Items */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightItemExchange"
        aria-labelledby="offcanvasRightLabel"
        style={{
          minWidth: offcanvasWidth,
          maxWidth: offcanvasWidth,
        }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Exchange Items</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body p-4">
          <div className="row mb-2">
            <div className="col-12">
              <label>
                Item <span>*</span>
              </label>
              <Select
                options={productsList?.map((prod) => ({
                  value: prod.Id,
                  label: prod.ProductName,
                }))}
                className="select"
                placeholder="product"
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                onChange={handleSelectProduct}
              />
            </div>
          </div>
          <div
            className="table-responsive"
            style={{ maxHeight: "24rem", overflowY: "auto" }}
          >
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedExchangeProducts?.map((item, index) => (
                  <tr key={item.Id}>
                    <td>{index + 1}</td>
                    <td>{item.ProductName}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter qty"
                        style={{ width: "5rem" }}
                        onChange={(e) =>
                          handleQuantityChange(
                            index,
                            parseInt(e.target.value) || 1
                          )
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                    <td>₹{item.AvgPrice.toLocaleString("en-IN")}</td>
                    <td>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleRemoveItem(index)}
                      >
                        <i className="fa-regular fa-trash-can text-white"></i>
                      </button>
                    </td>
                  </tr>
                ))}
                <tr className="sticky-bottom">
                  <td colSpan="4">
                    <strong>Total Amount</strong>
                  </td>
                  <td>
                    <strong>
                      ₹{totalExchangeAmount.toLocaleString("en-IN")}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button
            type="button"
            className="btn d-flex m-auto btn-success sticky-bottom mt-1"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            OK
          </button>
        </div>
      </div>
      {/* /Exchange Items */}

      {/* Recent Transactions */}
      <div
        className="modal fade pos-modal"
        id="recents"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Recent Transactions</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <div className="tabs-sets">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="purchase-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#purchase"
                      type="button"
                      aria-controls="purchase"
                      aria-selected="true"
                      role="tab"
                    >
                      Purchase
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="payment-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#payment"
                      type="button"
                      aria-controls="payment"
                      aria-selected="false"
                      role="tab"
                    >
                      Payment
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="return-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#return"
                      type="button"
                      aria-controls="return"
                      aria-selected="false"
                      role="tab"
                    >
                      Return
                    </button>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="purchase"
                    role="tabpanel"
                    aria-labelledby="purchase-tab"
                  >
                    <div className="table-top">
                      <div className="search-set">
                        <div className="search-input">
                          <input
                            type="text"
                            placeholder="Search"
                            className="form-control form-control-sm formsearch"
                          />
                          <Link to className="btn btn-searchset">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="wordset">
                        <ul>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderTooltip}
                            >
                              <Link>
                                <ImageWithBasePath
                                  src="assets/img/icons/pdf.svg"
                                  alt="img"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderExcelTooltip}
                            >
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                              >
                                <ImageWithBasePath
                                  src="assets/img/icons/excel.svg"
                                  alt="img"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderPrinterTooltip}
                            >
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                              >
                                <i
                                  data-feather="printer"
                                  className="feather-printer"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table datanew">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Reference</th>
                            <th>Customer</th>
                            <th>Amount </th>
                            <th className="no-sort">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0101</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0102</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0103</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0104</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0105</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0106</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0107</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="payment" role="tabpanel">
                    <div className="table-top">
                      <div className="search-set">
                        <div className="search-input">
                          <input
                            type="text"
                            placeholder="Search"
                            className="form-control form-control-sm formsearch"
                          />
                          <Link to className="btn btn-searchset">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="wordset">
                        <ul>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderTooltip}
                            >
                              <Link>
                                <ImageWithBasePath
                                  src="assets/img/icons/pdf.svg"
                                  alt="img"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderExcelTooltip}
                            >
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                              >
                                <ImageWithBasePath
                                  src="assets/img/icons/excel.svg"
                                  alt="img"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderPrinterTooltip}
                            >
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                              >
                                <i
                                  data-feather="printer"
                                  className="feather-printer"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table datanew">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Reference</th>
                            <th>Customer</th>
                            <th>Amount </th>
                            <th className="no-sort">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0101</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0102</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0103</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0104</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0105</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0106</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0107</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="return" role="tabpanel">
                    <div className="table-top">
                      <div className="search-set">
                        <div className="search-input">
                          <input
                            type="text"
                            placeholder="Search"
                            className="form-control form-control-sm formsearch"
                          />
                          <Link to className="btn btn-searchset">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                          </Link>
                        </div>
                      </div>
                      <div className="wordset">
                        <ul>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderTooltip}
                            >
                              <Link>
                                <ImageWithBasePath
                                  src="assets/img/icons/pdf.svg"
                                  alt="img"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderExcelTooltip}
                            >
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                              >
                                <ImageWithBasePath
                                  src="assets/img/icons/excel.svg"
                                  alt="img"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={renderPrinterTooltip}
                            >
                              <Link
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                              >
                                <i
                                  data-feather="printer"
                                  className="feather-printer"
                                />
                              </Link>
                            </OverlayTrigger>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table datanew">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Reference</th>
                            <th>Customer</th>
                            <th>Amount </th>
                            <th className="no-sort">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0101</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0102</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0103</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0104</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0105</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0106</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0107</td>
                            <td>Walk-in Customer</td>
                            <td>$1500.00</td>
                            <td className="action-table-data">
                              <div className="edit-delete-action">
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="eye"
                                    className="feather-eye"
                                  />
                                </Link>
                                <Link className="me-2 p-2" to="#">
                                  <i
                                    data-feather="edit"
                                    className="feather-edit"
                                  />
                                </Link>
                                <Link
                                  onClick={showConfirmationAlert}
                                  className="p-2 confirm-text"
                                  to="#"
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Recent Transactions */}

      {/* Recent orders */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewOrdersList"
        aria-labelledby="offcanvasRightLabel"
        style={{
          minWidth: offcanvasWidth,
          maxWidth: offcanvasWidth,
        }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Orders</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body p-2">
          <div className="tabs-sets">
            <ul className="nav nav-tabs sticky-top bg-white" id="myTabs" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="onhold-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#onhold"
                  type="button"
                  aria-controls="onhold"
                  aria-selected="true"
                  role="tab"
                >
                  Onhold
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="unpaid-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#unpaid"
                  type="button"
                  aria-controls="unpaid"
                  aria-selected="false"
                  role="tab"
                >
                  Unpaid
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  type="button"
                >
                  Paid
                </button>
              </li>
            </ul>
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="onhold"
                role="tabpanel"
                aria-labelledby="onhold-tab"
              >
                <div className="table-top">
                  <div className="search-set w-100 search-order">
                    <div className="search-input w-100">
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm formsearch w-100"
                      />
                      <Link to className="btn btn-searchset">
                        <i data-feather="search" className="feather-search" />
                      </Link>
                    </div>
                  </div>
                </div>
                {ordersData?.map((item, index) => (
                  <div className="order-body" key={index}>
                    <div className="default-cover p-4 mb-4">
                      <span className="badge bg-secondary d-inline-block mb-4">
                        Order ID : #{item.OrderNo}
                      </span>
                      <div className="row">
                        <div className="col-sm-12 col-md-6 record mb-3">
                          <table>
                            <tbody>
                              <tr className="mb-3">
                                <td>Cashier</td>
                                <td className="colon">:</td>
                                <th className="text">{item.StoreName}</th>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td className="colon">:</td>
                                <th className="text">{item.CustomerName}</th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="col-sm-12 col-md-6 record mb-3">
                          <table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td className="colon">:</td>
                                <th className="text">₹{item.Total}</th>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td className="colon">:</td>
                                <th className="text">
                                  {formatOrderDate(item.OrderDate)}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {/* <p className="p-4">
                        Customer need to recheck the product once
                      </p> */}
                      <div className="btn-ro d-flex align-items-center justify-content-between">
                        <Link
                          to="#"
                          className="btn btn-info btn-icon flex-fill"
                        >
                          Open
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-danger btn-icon flex-fill"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasRightViewOrdersDetails"
                          aria-controls="offcanvasRightViewOrdersDetails"
                          onClick={() => viewOrderData(item.Id)}
                        >
                          Details
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-success btn-icon flex-fill"
                          onClick={() => downloadPDF(item.Id)}
                        >
                          Print
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="tab-pane fade" id="unpaid" role="tabpanel">
                <div className="table-top">
                  <div className="search-set w-100 search-order">
                    <div className="search-input w-100">
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm formsearch w-100"
                      />
                      <Link to className="btn btn-searchset">
                        <i data-feather="search" className="feather-search" />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="order-body">
                  <div className="default-cover p-4 mb-4">
                    <span className="badge bg-info d-inline-block mb-4">
                      Order ID : #666662
                    </span>
                    <div className="row">
                      <div className="col-sm-12 col-md-6 record mb-3">
                        <table>
                          <tbody>
                            <tr className="mb-3">
                              <td>Cashier</td>
                              <td className="colon">:</td>
                              <td className="text">admin</td>
                            </tr>
                            <tr>
                              <td>Customer</td>
                              <td className="colon">:</td>
                              <td className="text">Anastasia</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col-sm-12 col-md-6 record mb-3">
                        <table>
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td className="colon">:</td>
                              <td className="text">$2500</td>
                            </tr>
                            <tr>
                              <td>Date</td>
                              <td className="colon">:</td>
                              <td className="text">10-09-2023 17:15:11</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <p className="p-4">
                      Customer need to recheck the product once
                    </p>
                    <div className="btn-row d-flex align-items-center justify-content-between">
                      <Link to="#" className="btn btn-info btn-icon flex-fill">
                        Open
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-danger btn-icon flex-fill"
                      >
                        Details
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-success btn-icon flex-fill"
                      >
                        Print
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="paid" role="tabpanel">
                <div className="table-top">
                  <div className="search-set w-100 search-order">
                    <div className="search-input w-100">
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm formsearch w-100"
                      />
                      <Link to className="btn btn-searchset">
                        <i data-feather="search" className="feather-search" />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="order-body">
                  <div className="default-cover p-4 mb-4">
                    <span className="badge bg-primary d-inline-block mb-4">
                      Order ID : #666665
                    </span>
                    <div className="row">
                      <div className="col-sm-12 col-md-6 record mb-3">
                        <table>
                          <tbody>
                            <tr className="mb-3">
                              <td>Cashier</td>
                              <td className="colon">:</td>
                              <td className="text">admin</td>
                            </tr>
                            <tr>
                              <td>Customer</td>
                              <td className="colon">:</td>
                              <td className="text">Hugo</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col-sm-12 col-md-6 record mb-3">
                        <table>
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td className="colon">:</td>
                              <td className="text">$5000</td>
                            </tr>
                            <tr>
                              <td>Date</td>
                              <td className="colon">:</td>
                              <td className="text">13-09-2023 19:39:11</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <p className="p-4">
                      Customer need to recheck the product once
                    </p>
                    <div className="btn-row d-flex align-items-center justify-content-between">
                      <Link to="#" className="btn btn-info btn-icon flex-fill">
                        Open
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-danger btn-icon flex-fill"
                      >
                        Details
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-success btn-icon flex-fill"
                      >
                        Print
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Recent orders */}

      {/* View order details */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewOrdersDetails"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Order Details</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body p-2">
          <div className="tabs-sets">
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="onhold"
                role="tabpanel"
                aria-labelledby="onhold-tab"
              >
                <div className="order-body">
                  <div className="default-cover p-4 mb-4">
                    <span className="badge bg-secondary d-inline-block mb-4">
                      Order ID : #
                      {orderViewData && orderViewData[0]
                        ? orderViewData[0].OrderNo
                        : "N/A"}
                    </span>
                    <div className="row">
                      <div className="col-sm-12 col-md-6 record mb-3">
                        <table>
                          <tbody>
                            <tr className="mb-3">
                              <td>Cashier</td>
                              <td className="colon">:</td>
                              <th className="text">
                                {orderViewData && orderViewData[0]
                                  ? orderViewData[0].StoreName
                                  : "N/A"}
                              </th>
                            </tr>
                            <tr>
                              <td>Customer</td>
                              <td className="colon">:</td>
                              <th className="text">
                                {orderViewData && orderViewData[0]
                                  ? orderViewData[0].CustomerName
                                  : "N/A"}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col-sm-12 col-md-6 record mb-3">
                        <table>
                          <tbody>
                            <tr>
                              <td>Total</td>
                              <td className="colon">:</td>
                              <th className="text">
                                ₹
                                {orderViewData && orderViewData[0]
                                  ? orderViewData[0].Total.toLocaleString("en-IN")
                                  : "N/A"}
                              </th>
                            </tr>
                            <tr>
                              <td>Date</td>
                              <td className="colon">:</td>
                              <th className="text">
                                {formatOrderDate(
                                  orderViewData && orderViewData[0]
                                    ? orderViewData[0].OrderDate
                                    : "N/A"
                                )}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Making Charges</th>
                            <th>Other Charges</th>
                            <th>Metal Type</th>
                            <th>Purity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderViewLoading ? (
                            <tr>
                              <td colSpan="12" style={{ textAlign: "center" }}>Loading...</td>
                            </tr>
                          ) : orderViewData && orderViewData.length > 0 ? (
                            orderViewData.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.ProductName}</td>
                                <td>{item.Quantity}</td>
                                <td>{item.UnitPrice}</td>
                                <td>{item.MakingCharges}</td>
                                <td>{item.OtherCharges}</td>
                                <td>{item.MetalType}</td>
                                <td>{item.Purity}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" style={{ textAlign: "center" }}>No data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* View order details */}

      {/* Print Receipt */}
      <div
        ref={printRef}
        className="container col-12"
        style={{ display: isVisible ? 'block' : 'none' }}
      >
        <div
          className="center-image"
          style={{ textAlign: "center", margin: "10px" }}
        >
          <img
            src={PrintLogo}
            alt="Jewellery Image"
            width="180px"
            height="40px"
          />
        </div>
        <hr />

        <div
          className="d-flex"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
            paddingLeft: "15px",
          }}
        >
          <h3 style={{ textAlign: "left", color: "#FF9F43" }}>
            Jewellery Receipt
          </h3>
          <div>
            <p style={{ margin: 0 }}>Date: {orderDownlaodData && orderDownlaodData[0]
                                  ? formatOrderDate(orderDownlaodData[0].OrderDate)
                                  : "N/A"}</p>
            <h4 style={{ textAlign: "left", color: "#FF9F43", margin: 0 }}>
              {/* TR - {stockTRPdf?.[0]?.AutoGenTransactionNo || ""} */}
              <span className="fw-semibold"></span>{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].OrderNo
                                  : "N/A"}
            </h4>
          </div>
        </div>

        <div
          className="vendor-ship"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ width: "48%" }}>
            <p
              className="ship"
              style={{
                backgroundColor: "#FF9F43",
                color: "white",
                padding: "10px",
                fontWeight: "bold",
              }}
            >
              <strong>Merchant Details</strong>
            </p>
            <p>
              Name: <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].StoreName
                                  : "N/A"}</span>
            </p>
            <p>
              Phone No: <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].StorePhone
                                  : "N/A"}</span>
            </p>
            <p>
              Email Id:{" "}
              <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].StoreEmail
                                  : "N/A"}</span>
            </p>
            <p>
              City: <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].StoreCity
                                  : "N/A"}</span>
            </p>
            <p>
              State: <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].StoreState
                                  : "N/A"}</span>
            </p>
            <p>
              Address:{" "}
              <span className="fw-semibold">
              {orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].StoreAddress
                                  : "N/A"}
              </span>
            </p>
          </div>
          <div style={{ width: "48%" }}>
            <p
              className="ship"
              style={{
                backgroundColor: "#FF9F43",
                color: "white",
                padding: "10px",
                fontWeight: "bold",
              }}
            >
              <strong>Customer Details</strong>
            </p>
            <p>
              Name:
              <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0] ? orderDownlaodData[0].CustomerName : "N/A"}</span>
            </p>
            <p>
              Phone No: <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].CustomerPhone
                                  : "N/A"}</span>
            </p>
            <p>
              Email Id:
              <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].CustomerEmail
                                  : "N/A"}</span>
            </p>
            <p>
              City: <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].CustomerCity
                                  : "N/A"}</span>
            </p>
            <p>
              State: <span className="fw-semibold">{orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].CustomerState
                                  : "N/A"}</span>
            </p>
            <p>
              Address:
              <span className="fw-semibold">
              {orderDownlaodData && orderDownlaodData[0]
                                  ? orderDownlaodData[0].CustomerAddress
                                  : "N/A"}
              </span>
            </p>
          </div>
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "15px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                #
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                Item Description
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                Purity
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                Weight
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                Quantity
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                Unit Price(₹)
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                Total Price(₹)
              </th>
            </tr>
          </thead>
          <tbody>
            {orderDownlaodData?.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "0.5px solid #000", padding: "10px" }}>
                  {index + 1}
                </td>
                <td style={{ border: "0.5px solid #000", padding: "10px" }}>
                  {item.ProductName} ({item.MetalType})
                </td>
                <td style={{ border: "1px solid #000", padding: "10px" }}>
                  {item.Purity}
                </td>
                <td style={{ border: "1px solid #000", padding: "10px" }}>
                  {item.Weight}
                </td>
                <td style={{ border: "1px solid #000", padding: "10px" }}>
                  {item.Quantity}
                </td>
                <td style={{ border: "1px solid #000", padding: "10px" }}>
                  {item.UnitPrice.toLocaleString("en-IN")}
                </td>
                <td style={{ border: "1px solid #000", padding: "10px" }}>
                  {(item.Quantity * item.UnitPrice).toLocaleString("en-IN")}
                </td>
              </tr>
            ))}

            <tr>
              <td
                colSpan="6"
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  fontWeight: "bold",
                  textAlign: "right",
                }}
              >
                Total:
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "10px",
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                {orderDownlaodData && orderDownlaodData[0]
                  ? parseFloat(orderDownlaodData[0].Total).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "N/A"}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex row">
          <div className="col-12">
            <p>
              <strong>Additional Notes & Care Instructions:</strong>
            </p>
            <p>- Verify the weight and quality upon receipt.</p>
            <p>- Please handle all jewelry items with care to avoid damage.</p>
            <p>
              - Store each piece as recommended to preserve its quality and
              appearance.
            </p>
            <p className="text-center text-info">
              We appreciate your trust in our craftsmanship.
            </p>
          </div>
        </div>

        <div
          className="footer"
          style={{
            fontSize: "12px",
            textAlign: "center",
            color: "gray",
            marginTop: "20px",
          }}
        >
          <p>
            For any inquiries or support regarding this purchase, please reach
            out to our customer service team.
          </p>
          <p>
            Contact us at <strong>perennialjewellery@gold.com</strong> or call{" "}
            <strong>+91-XXXX-XXXXXX</strong>.
          </p>
        </div>
      </div>
      {/* Print Receipt */}
    </div>
  );
};

export default JewelleryPOS;
